<div [style]='"max-width:"+size+"px;"+style' class='lottie-container'>
  <ng-lottie [options]='options'></ng-lottie>
</div>
